export interface PdfExportConfigDialogProps {
  open: boolean;
  onClose: () => void;
}

// PDF Export Options
export enum PdfExportOption {
  VALUATIONS = 'valuations',
  OTHER = 'other',
  FUND = 'fund',
  FIRM = 'firm',
}

// Company sub-options
export interface CompanyPdfOptions {
  valuationSummary: boolean;
  equityAllocation: boolean;
  concludedShareValues: boolean;
  financials: boolean;
  capTable: boolean;
  fundOwnership: boolean;
  breakpointAnalysis: boolean;
  cashFlowLedger: boolean;
  valuationApproaches: boolean;
}

// Fund sub-options
export interface FundPdfOptions {
  summary: boolean;
  scheduleOfInvestments: boolean;
}

// Firm sub-options
export interface FirmPdfOptions {
  summary: boolean;
}

// Main PDF export configuration
export interface PdfExportConfiguration {
  selectedOption: PdfExportOption;
  companyOptions: CompanyPdfOptions;
  fundOptions: FundPdfOptions;
  firmOptions: FirmPdfOptions;
}

// Company option configurations for UI and processing
export const COMPANY_OPTION_CONFIGS: Array<{ key: keyof CompanyPdfOptions; label: string }> = [
  { key: 'valuationSummary', label: 'Valuation Summary' },
  { key: 'equityAllocation', label: 'Equity Allocation' },
  { key: 'concludedShareValues', label: 'Concluded Share Values' },
  { key: 'financials', label: 'Financials' },
  { key: 'capTable', label: 'Cap Table' },
  { key: 'fundOwnership', label: 'Fund Ownership' },
  { key: 'breakpointAnalysis', label: 'Breakpoints' },
  { key: 'cashFlowLedger', label: 'Cash Flow Ledger' },
  { key: 'valuationApproaches', label: 'Valuation Approaches' },
];

// Default configurations
export const DEFAULT_COMPANY_OPTIONS: CompanyPdfOptions = {
  valuationSummary: true,
  equityAllocation: true,
  concludedShareValues: true,
  financials: true,
  capTable: true,
  fundOwnership: true,
  breakpointAnalysis: true,
  cashFlowLedger: true,
  valuationApproaches: true,
};

export const DEFAULT_FUND_OPTIONS: FundPdfOptions = {
  summary: true,
  scheduleOfInvestments: true,
};

export const DEFAULT_FIRM_OPTIONS: FirmPdfOptions = {
  summary: true,
};

export const DEFAULT_PDF_CONFIGURATION: PdfExportConfiguration = {
  selectedOption: PdfExportOption.VALUATIONS,
  companyOptions: DEFAULT_COMPANY_OPTIONS,
  fundOptions: DEFAULT_FUND_OPTIONS,
  firmOptions: DEFAULT_FIRM_OPTIONS,
};
